import { render, staticRenderFns } from "./review-close.vue?vue&type=template&id=a25bc872"
import script from "./review-close.vue?vue&type=script&lang=ts"
export * from "./review-close.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports